var map = {
	"./skins/IBC-dyst": [
		195,
		21
	],
	"./skins/IBC-dyst-2025": [
		194,
		22
	],
	"./skins/IBC-dyst-2025.css": [
		556,
		47
	],
	"./skins/IBC-dyst-2025.js": [
		194,
		22
	],
	"./skins/IBC-dyst.css": [
		557,
		46
	],
	"./skins/IBC-dyst.js": [
		195,
		21
	],
	"./skins/aktionaerliga-2024": [
		196,
		20
	],
	"./skins/aktionaerliga-2024.css": [
		558,
		45
	],
	"./skins/aktionaerliga-2024.js": [
		196,
		20
	],
	"./skins/aktionaerliga-2025": [
		197,
		19
	],
	"./skins/aktionaerliga-2025.css": [
		559,
		44
	],
	"./skins/aktionaerliga-2025.js": [
		197,
		19
	],
	"./skins/aktionaerliga-2026": [
		198,
		18
	],
	"./skins/aktionaerliga-2026.css": [
		560,
		43
	],
	"./skins/aktionaerliga-2026.js": [
		198,
		18
	],
	"./skins/bibliotekarernes-sep-2024": [
		199,
		17
	],
	"./skins/bibliotekarernes-sep-2024.css": [
		561,
		42
	],
	"./skins/bibliotekarernes-sep-2024.js": [
		199,
		17
	],
	"./skins/boersen-spiel-sep-2024": [
		200,
		16
	],
	"./skins/boersen-spiel-sep-2024.css": [
		562,
		41
	],
	"./skins/boersen-spiel-sep-2024.js": [
		200,
		16
	],
	"./skins/borsgruppenliu-jan-2024": [
		201,
		15
	],
	"./skins/borsgruppenliu-jan-2024.css": [
		563,
		40
	],
	"./skins/borsgruppenliu-jan-2024.js": [
		201,
		15
	],
	"./skins/eadania": [
		202,
		14
	],
	"./skins/eadania.css": [
		564,
		39
	],
	"./skins/eadania.js": [
		202,
		14
	],
	"./skins/fynske-bank-sep-2024": [
		203,
		13
	],
	"./skins/fynske-bank-sep-2024.css": [
		565,
		38
	],
	"./skins/fynske-bank-sep-2024.js": [
		203,
		13
	],
	"./skins/ibc-jan-2024": [
		204,
		23
	],
	"./skins/ibc-jan-2024.js": [
		204,
		23
	],
	"./skins/rosborg-gym-2026": [
		205,
		12
	],
	"./skins/rosborg-gym-2026.css": [
		566,
		37
	],
	"./skins/rosborg-gym-2026.js": [
		205,
		12
	],
	"./skins/sdu-businessschooldays-2024": [
		206,
		11
	],
	"./skins/sdu-businessschooldays-2024.css": [
		567,
		36
	],
	"./skins/sdu-businessschooldays-2024.js": [
		206,
		11
	],
	"./skins/sdu-businessschooldays-2025": [
		207,
		10
	],
	"./skins/sdu-businessschooldays-2025.css": [
		568,
		35
	],
	"./skins/sdu-businessschooldays-2025.js": [
		207,
		10
	],
	"./skins/skoledyst-oct-2023": [
		208,
		9
	],
	"./skins/skoledyst-oct-2023.css": [
		569,
		34
	],
	"./skins/skoledyst-oct-2023.js": [
		208,
		9
	],
	"./skins/skolernes-aktiedyst-2024": [
		209,
		8
	],
	"./skins/skolernes-aktiedyst-2024.css": [
		570,
		33
	],
	"./skins/skolernes-aktiedyst-2024.js": [
		209,
		8
	],
	"./skins/skolernes-aktiedyst-2025": [
		210,
		7
	],
	"./skins/skolernes-aktiedyst-2025.css": [
		571,
		32
	],
	"./skins/skolernes-aktiedyst-2025.js": [
		210,
		7
	],
	"./skins/sommerdysten-ad-2023": [
		211,
		6
	],
	"./skins/sommerdysten-ad-2023.css": [
		572,
		31
	],
	"./skins/sommerdysten-ad-2023.js": [
		211,
		6
	],
	"./skins/sommerdysten-ak-2023": [
		212,
		5
	],
	"./skins/sommerdysten-ak-2023.css": [
		573,
		30
	],
	"./skins/sommerdysten-ak-2023.js": [
		212,
		5
	],
	"./skins/sommerdysten-is-2023": [
		213,
		4
	],
	"./skins/sommerdysten-is-2023.css": [
		574,
		29
	],
	"./skins/sommerdysten-is-2023.js": [
		213,
		4
	],
	"./skins/sydbank-sep-2020": [
		214,
		3
	],
	"./skins/sydbank-sep-2020.css": [
		575,
		28
	],
	"./skins/sydbank-sep-2020.js": [
		214,
		3
	],
	"./skins/targo-2025": [
		215,
		2
	],
	"./skins/targo-2025.css": [
		576,
		27
	],
	"./skins/targo-2025.js": [
		215,
		2
	],
	"./skins/ung_aktiedyst_2025": [
		216,
		1
	],
	"./skins/ung_aktiedyst_2025.css": [
		577,
		26
	],
	"./skins/ung_aktiedyst_2025.js": [
		216,
		1
	],
	"./skins/ungdomsudddyst-oct-2024": [
		217,
		0
	],
	"./skins/ungdomsudddyst-oct-2024.css": [
		578,
		25
	],
	"./skins/ungdomsudddyst-oct-2024.js": [
		217,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 362;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/dynamic lazy ^\.\/.*$
// module id = 362
// module chunks = 48